import type { SxProps, Theme } from "@mui/material";
import type { ReactNode } from "react";

import { Box, Drawer } from "@mui/material";

interface DetailBottomSheetProps {
	ariaLabelledBy?: string;
	children: ReactNode;
	disableRestoreFocus?: boolean;
	onClose: () => void;
	onEntered?: () => void;
	onExited?: () => void;
	open: boolean;
	paperSx?: SxProps<Theme>;
}

const SHEET_PAPER_SX = {
	borderTopLeftRadius: 16,
	borderTopRightRadius: 16,
	maxHeight: "85dvh",
	maxWidth: "min(800px, 100vw)",
	mx: "auto",
	overflowX: "hidden",
	width: "100%"
} as const;

const DetailBottomSheet = ({
	ariaLabelledBy,
	children,
	disableRestoreFocus = false,
	onClose,
	onEntered,
	onExited,
	open,
	paperSx
}: DetailBottomSheetProps) => (
	<Drawer
		anchor="bottom"
		disableRestoreFocus={disableRestoreFocus}
		onClose={onClose}
		open={open}
		slotProps={{
			paper: {
				...(ariaLabelledBy ? { "aria-labelledby": ariaLabelledBy, "aria-modal": true, role: "dialog" } : {}),
				sx: paperSx ? [SHEET_PAPER_SX, ...(Array.isArray(paperSx) ? paperSx : [paperSx])] : SHEET_PAPER_SX
			},
			transition: { onEntered, onExited }
		}}
	>
		<Box sx={{ bgcolor: "divider", borderRadius: 2, flexShrink: 0, height: 4, mt: 1, mx: "auto", width: 36 }} />
		{children}
	</Drawer>
);

export default DetailBottomSheet;
